import { gql } from "lib/apolloClient";
import { attachmentFragment } from "modules/CommonFragments";

export const updateAttachmentMutation = gql`
  mutation updateAttachment($input: AttachmentUpdateInput!) {
    platform {
      updateAttachment(input: $input) {
        ...attachmentItem
        modalityAttachment {
          ... on ModalityFile {
            id
            content
          }
        }
      }
    }
  }
  ${attachmentFragment.attachment}
`;
